<template>
  <div class="background-color">
    <div class="comments-title-container">

      <div class="flex-space-between">

        <div class="field add-comment-button">
          <p class="control">
            <input
              @click="toggleDisplayAddComment()"
              class="button is-info"
              :disabled="loading || video == null"
              type="button"
              value="Add Comment"
              />
            <input
              @click="toggleAddTag()"
              class="button is-warning"
              :disabled="loading || video == null"
              type="button"
              value="Add Tag"
              />
          </p>
        </div>

        <div class="field search" :class="searchFocused && 'is-active'">
          <p class="control">
            <input
              @focus="searchFocused = true"
              @blur="searchFocused = false"
              class='input'
              type='text'
              name='search'
              placeholder='search'
              v-model='query'
              :disabled="loading"
            />
          </p>
        </div>
      </div>

    </div>

    <AddTagModal
      @close="showAddTagModal = false"
      :show="showAddTagModal"
      :videoID="videoID"
      :commentID=0
      :currentTime="currentTime"
     />

    <AddComment v-if="displayAddComment"
      :avatar_url="user.avatar_url"
      @close="closeAddComment()"
      :cycleID="cycleID"
      :videoID="videoID"
      :currentTime="currentTime"
    />

    <article v-if="!loading && searchResults != null && searchResults.length > 0">
      <Scroll height="82vh">

        <Comment v-for="comment in searchResults"
          :key="comment.id"
          :cycleID="cycleID"
          :videoID="videoID"
          :userID="userID"
          :elements="comment.elements"
          :id="comment.id"
          :replies="comment.replies"
          :replies_editing="comment.replies_editing"
          :user="comment.user"
          :body="comment.body"
          :created_on="comment.created_on"
          :active="comment.active"
          :start_time="comment.start_time"
          :end_time="comment.end_time"
          :tags="comment.tags"
          :scores="comment.scores"
          class="mb-3 mr-2"
        />

      </Scroll>
    </article>

    <p v-else-if="query !== '' && !loading"
      class="no-results break-word">
        No results for query <strong>{{ query }}</strong>
    </p>
    <p class="nothing-message text-muted" v-else-if="!loading">No comments yet</p>

    <Loader v-if="loading"/>

  </div>
</template>

<script>

import Loader from './Loader.vue'
import Comment from './Comment.vue'
import AddComment from './AddComment.vue'
import AddTagModal from './AddTagModal.vue'
import Scroll from './Scroll.vue'

import store from '../store.js'

import { prettyDate, prettyCommentTime } from '../filters.js'

export default {
  name: 'Comments',
  mounted () {
    store.dispatch('fetchRubricElements')
  },
  props: {
    videoID: {
      type: Number,
      required: true,
    },
    cycleID: {
      type: Number,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    currentTime: {
      type: Number,
      required: true,
    },
    video: {
      type: Object,
      required: true,
    },
    comments: {
      type: Array,
      required: true,
    }
  },
  components: {
    Comment,
    Loader,
    AddComment,
    AddTagModal,
    Scroll,
  },
  methods: {
    closeAddComment () {
      store.commit('setDisplayAddComment', false)
    },
    toggleDisplayAddComment () {
      if (!this.displayAddComment) {
        this.$emit('pause')
      }
      store.commit('setDisplayAddComment', !this.displayAddComment)
    },
    toggleAddTag () {
      this.$emit('pause')
      this.showAddTagModal = true
    }
  },
  filters: {
    prettyDate,
    prettyCommentTime,
  },
  data () {
    return {
      searchFocused: false,
      showAddTagModal: false,
      query: '',
    }
  },
  computed: {
    cycle () {
      return store.state.cycles
        .find(x => x.id === this.cycleID)
    },
    searchResults () {
      // 1. sort by start time so earliest are at the top
      // 2. sort futher by Date such that earliest are at the top.
      return this.comments
        .filter(x =>
          x.body.toUpperCase().includes(this.query.toUpperCase()) ||
          x.replies.filter(y =>
            y.body.toUpperCase().includes(this.query.toUpperCase())
          ).length > 0
        )
        .sort((a, b) =>
          a.start_time !== b.start_time
          ? a.start_time - b.start_time
          : new Date(a.created_on) - new Date(b.created_on))
    },
    userID () {
      return store.state.user.id
    },
    user () {
      return store.state.user
    },
    displayAddComment () {
      return store.state.displayAddComment
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../_variables.scss';

.comments-title-container {
  align-items: center;
}

.no-results {
  text-align: center;
  margin-bottom: 5px;
  font-size: 1.2rem;
}

.nothing-message {
  text-align: center;
  font-weight: 500;
  font-size: 1.2rem;
  padding: 1rem;
}

// Bulma override so comments aren't space weird
.content:not(:last-child) {
  margin-bottom: 0;
}


@import '../_variables.scss';

.more-icon {
  width: 2rem;
  fill: $nice-darkergray;
}

.center {
  text-align: center;
}

.add-comment-button {
  margin-right: 1rem;
}

.search {
  transition: all 0.2s;
  &.is-active {
    flex-grow: 1;
  }
}
</style>



// WEBPACK FOOTER //
// Comments.vue?05f100ab